import {MAIN_COLOR} from "../../../components/globalThemes";
import {Link} from "react-router-dom";
import styled from 'styled-components';

export const SquarePost = styled(Link)`
    width: 100%;
    max-width: 400px;
    height: 280px;
    min-width: 200px;
    margin: 30px;
    border: 1px solid ${MAIN_COLOR};   
    display: flex;
    flex-direction: column;
    cursor: pointer;
    background-color: #1F1F1F;
    position: relative;
    text-decoration: none;
    color: black;
    z-index: 1;
    
    &:hover {
        opacity: 0.8;
    }
    
    @media screen and (orientation:portrait) {
        transform: scale(0.9);
    }
`;

export const PostImage = styled.img`
    width: 100%;
    height: 100%;
    max-height: 200px;
    filter: brightness(70%);
    object-fit: ${({image, error}) => (image && !error) ? 'cover' : 'contain'};
`;

export const PostPanel = styled.div`
    background-color: black;
    width: 100%;
    flex: 1;
    position: relative;
`;

export const PostContent = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
`;

export const PostTitle = styled.p`
    color: silver;
    font-size: 12px;
    font-family: Roboto Condensed, serif;
    border-left: 10px solid ${MAIN_COLOR};
    padding-left: 5px;
    margin-right: 10px;
    margin-bottom: 0;
`;

export const PostSubtitle = styled.p`
    color: #A9A9A9;
    font-size: 10px;
    font-family: Roboto Condensed, serif;
    margin-left: 15px;
    height: 10px;
    margin-bottom: 0;
`;

export const PostText = styled.p`
    color: white;
    font-size: 10px;
    font-family: Roboto Condensed, serif;
    margin-left: 15px;
    height: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 15px;
`;

export const PostSign = styled.div`
    width: 120px;
    height: 20px;
    background-color: black;
    z-index: 5;
    position: absolute;
    right: 0;
    top: -20px;
    clip-path: polygon(50% 0, 100% 0, 100% 100%, 0% 100%);
`;

export const PostSignText = styled.p`
    color: white;
    font-family: Roboto Condensed, serif;
    margin-left: 55px;
    margin-top: 6px;
    font-size: 10px;
`;

export const LinkButton = styled.div`
    width: 0px;
    height: 20px;
    position: absolute;
    right: 0;
    background-color: ${MAIN_COLOR};
    top: 40%;  
    font-size: 11px;
    font-weight: 300;
    font-family: Roboto Condensed, serif;
    text-align: center;
    line-height: 20px;
    clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
    transition: width 3s;
    
    &:before {
        content: "// ";
        letter-spacing: 1px;
        font-weight: bold;
    }
    
    ${SquarePost}:hover & {
        width: 150px;
    }
`;
